import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const getInterviewConfigLookups = async () => {
  const url = `${API_ENDPOINT.GET_INTERVIEW_CONFIG.LOOKUPS}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Lookup API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const createMixMatchInterview = async (payload) => {
  const url = `${API_ENDPOINT.CREATE_INTERVIEW.MIX_MATCH}`;
  try {
    const response = await axios.post(url, payload);
    return response;
  } catch (error) {
    console.error("Create mix match interview API Failed:", error);
    throw error.response || { message: "Network error" };
  }
}

export const getInterviewConfigList = async (
  page = 1,
  pageSize = 10,
  sortBy = "created_at",
  sortOrder = "DESC",
  filters = {},
  status,
) => {
  try {
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(pageSize),
      sort_by: sortBy,
      sort_order: sortOrder,
      ...(status != null && status !== "" ? { status } : {}),
      ...Object.fromEntries(
        Object.entries(filters).filter(([, v]) => v != null && v !== "")
      ),
    });
    const url = `${API_ENDPOINT.GET_INTERVIEW_CONFIG.LIST}?${params.toString()}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("get interview API Failed:", error);
    throw error.response || { message: "Network error" };
  }
};

export const updateInterviewStatus = async (id, status) => {
  try {
    const url = `${API_ENDPOINT.GET_INTERVIEW_CONFIG.UPDATE}/${id}`;

    const response = await axios.put(url, {
      id,
      status,
    });

    return response.data;
  } catch (error) {
    console.error("Update interview status API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
};

export const getInterviewTypesByCategory = async (categoryId) => {
  const url = `${API_ENDPOINT.GET_INTERVIEW_CONFIG.INTERVIEW_TYPE_BY_CATEGORY}/${categoryId}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Get interview types by category API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
}